export { UpvoteDownvoteFooter } from './UpvoteDownvoteFooter';
